module.exports = __webpack_public_path__ + "media/לב.f4970c2d.mp3";